import { render, staticRenderFns } from "./dealOrder.vue?vue&type=template&id=6ef38bd9&scoped=true"
import script from "./dealOrder.vue?vue&type=script&lang=js"
export * from "./dealOrder.vue?vue&type=script&lang=js"
import style0 from "./dealOrder.vue?vue&type=style&index=0&id=6ef38bd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef38bd9",
  null
  
)

export default component.exports